import Input from '../../../../../Core/Fields/Floating/Input';
import Date from '../../../../../Core/Fields/Floating/Date';
import Checkbox from '../../../../../Core/Fields/Floating/Checkbox';
import SelectSearchApi from '../../../../../Core/Fields/Floating/SelectSearchApi';

const GeneralDetailsTab = ({ formData, onFieldChange, customerData, salesPersonData, costCenterData, projectData, currencyData,PriceListData }) => {
    return (
        <div>
            <div className="px-2 py-3" style={{ background: 'white' }}>
                <div style={{ display: 'flex' }} >
                    <div className="col-md-6 px-2">
                        <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                        <p className='m-0' style={{fontSize:'16px',fontWeight:'600'}}>Details</p>
                                    </div>
                                </div>
                                    
                           <div style={{ display: 'flex', gap: '15px' }}>
  <div style={{ flex: 1 }}>
    <Input
      label="Series"
      style={{ height: "30px" }}
      value={formData.series}
      onChange={(e) => onFieldChange('series', e.target.value)}
    />
  </div>

  <div style={{ flex: 1 }}>
    <Date
      label="Posting Date"
      style={{ height: "30px" }}
      value={formData.posting_date}
      onChange={(e) => onFieldChange('posting_date', e.target.value)}
    />
  </div>
  <div style={{ flex: 1 }}>
    <Input
      label="Posting Time"
      style={{ height: "30px" }}
      value={formData.posting_time}
      onChange={(e) => onFieldChange('posting_time', e.target.value)}
    />
  </div>

  <div style={{ flex: 1 }}>
    <Date
      label="Payment Due Date"
      style={{ height: "30px" }}
      value={formData.payment_due_date}
      onChange={(e) => onFieldChange('payment_due_date', e.target.value)}
    />
  </div>
</div>

                            <div className='mb-2' style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <SelectSearchApi
                                        label="Customer"
                                        list={customerData.customer_List}
                                        getOptionLabel={(item) => item.value}
                                        getOptionValue={(item) => item.value}
                                        style={{ height: "30px" }}
                                        value={formData.customer}
                                        onChange={(e) => onFieldChange('customer',e)}
                                        onApiChange={(e) => customerData.refetch_Customer(e)}
                                    />
                                </div>
                                 <div style={{ flex: 1 }}>
                                    <Input label="Company" style={{ height: "30px" }} value={formData.company}  />
                                 </div>
                            </div>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <SelectSearchApi
                                        label="Sales Person"
                                        list={salesPersonData.sales_Person_List}
                                        getOptionLabel={(item) => item.value}
                                        getOptionValue={(item) => item.value}
                                        style={{ height: "30px" }}
                                        value={formData.sales_person}
                                        onChange={(e) => onFieldChange('sales_person', e)}
                                        onApiChange={(e) => salesPersonData.refetch_sales_Person(e)}
                                    />
                                </div>
                                 <div style={{ flex: 1 }}>

                                    {/* <Input label="Repair Id" style={{ height: "30px" }} value={formData.repair_job_id} onChange={(e) => onFieldChange('repair_id', e.target.value)} /> */}
                                   
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 px-2">
                        <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                           <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                        <p className='m-0' style={{fontSize:'16px',fontWeight:'600'}}>Accounting Dimensions</p>
                                    </div>
                                </div>
                            <div style={{ display: 'flex', gap: '15px' }}>
                          
                                <div style={{ flex: 1 }}>
                                    <SelectSearchApi
                                        list={costCenterData.cost_center_List}
                                        label="Cost Center"
                                        style={{ height: "30px" }}
                                        getOptionLabel={(item) => item.value}
                                        getOptionValue={(item) => item.value}
                                        value={formData.cost_center}
                                        onChange={(e) => onFieldChange('cost_center', e)}
                                        onApiChange={(e) => costCenterData.refetch_cost_center(e)}
                                    />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <SelectSearchApi
                                        list={projectData.project_List}
                                        label="Project"
                                        style={{ height: "30px" }}
                                        getOptionLabel={(item) => item.value}
                                        getOptionValue={(item) => item.value}
                                        value={formData.project}
                                        onChange={(e) => onFieldChange('project', e)}
                                        onApiChange={(e) => projectData.refetch_project(e)}
                                    />
                                </div>
                            </div>

                             <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                        <p className='mt-2 mb-0' style={{fontSize:'16px',fontWeight:'600'}}>Currency and Price List</p>
                                    </div>
                                </div>
                            <div style={{ display: 'flex', gap: '15px', marginBottom: '5px' }}>
                                <div style={{ flex: 1 }}>
                                    <SelectSearchApi
                                        label="Currency"
                                        list={currencyData.currency_List}
                                        getOptionLabel={(item) => item.value}
                                        getOptionValue={(item) => item.value}
                                        style={{ height: "30px" }}
                                        value={formData.currency}
                                        onChange={(e) => onFieldChange('currency', e)}
                                        onApiChange={(e) => currencyData.refetch_currency(e)}
                                    />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <SelectSearchApi
                                        label="Price List"
                                        list={PriceListData.priceList}
                                        style={{ height: "30px" }}
                                        value={formData.price_list}
                                        getOptionLabel={(item) => item.value}
                                        getOptionValue={(item) => item.value}
                                        onChange={(e) => onFieldChange('price_list', e)}
                                        onApiChange={(e) => PriceListData.refetch_priceList(e)}
                                    />
                                </div>
                                {/* <div style={{ flex: 1 }}>
                                <label style={{height:'19px'}}></label>
                                     <Checkbox
                                            id="IgnorePricingRule"
                                            label="Ignore Pricing Rule"
                                            value={formData.ipr}
                                            onChange={(e) => onFieldChange('ipr', formData.ipr ? false : true)}
                                        />
                                </div> */}
                            </div>


                        </div>
                    </div>
                </div>
            </div>
   
        </div>
    );
};

export default GeneralDetailsTab;